<script setup>
/**
 * FormHistoryOffcanvas
 * Provides a slide-out panel for viewing record history.
 * Listens to Bootstrap offcanvas events to toggle the 'open' state,
 * which controls the lazy-loading of the ItemHistory child component.
 */
import {ref, onMounted, onBeforeUnmount} from 'vue'
import ItemHistory from "@/common/item-history/ItemHistory.vue"

const props = defineProps({
    formId: {
        type: String,
        required: true
    }
})

// --- State ---

const open = ref(false)

// --- Handlers ---

const handleShow = () => {
    open.value = true
}
const handleHide = () => {
    open.value = false
}

// --- Lifecycle ---

onMounted(() => {
    const el = document.getElementById('historyOffcanvas')
    if (el) {
        el.addEventListener('show.bs.offcanvas', handleShow)
        el.addEventListener('hide.bs.offcanvas', handleHide)
    }
})

onBeforeUnmount(() => {
    const el = document.getElementById('historyOffcanvas')
    if (el) {
        el.removeEventListener('show.bs.offcanvas', handleShow)
        el.removeEventListener('hide.bs.offcanvas', handleHide)
    }
})
</script>

<template>
    <div
        id="historyOffcanvas"
        class="offcanvas offcanvas-end w-50"
        tabindex="-1"
        aria-labelledby="historyOffcanvasLabel"
    >
        <div class="offcanvas-header">
            <h5 id="historyOffcanvasLabel" class="offcanvas-title">History</h5>
            <button
                type="button"
                class="btn-close"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
            />
        </div>

        <div class="offcanvas-body">
            <ItemHistory v-if="open" :form-id="formId"/>
        </div>
    </div>
</template>